import { Flex, Header, ReferralInfo, Text } from '@components';
import { useUserQuery } from '@features/api/userSlice';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  ReferralContainer,
  StyledContainer,
  StyledCopyButton,
  StyledCopyLinkContainer,
  StyledGiftImage,
  StyledReferralInfoContainer,
} from './Referral.styles';
import Gift from '@assets/images/gift.png';
import { useTheme } from '@mui/material';
import { referralData } from './Referral.const';
import { useState } from 'react';

const Referral: React.FC = () => {
  const intl = useIntl();
  const theme = useTheme();
  const referralLink = 'www.swise.com/w/hdkfwk7';
  const { data: user } = useUserQuery();
  const [isCopied, setIsCopied] = useState(false);

  const onCopyButtonClick = async () => {
    await navigator.clipboard.writeText(referralLink);
    setIsCopied(true);
    const copyTime = setTimeout(() => {
      setIsCopied(false);
      clearTimeout(copyTime);
    }, 2000);
  };

  return (
    <StyledContainer>
      <Header
        user={user}
        title={{
          name: intl.formatMessage({ id: 'referral.referralProgram' }),
        }}
      />
      <Flex mt={17} mb={17} alignItems='center'>
        <Text
          variant='h3'
          fontWeight='fontWeightSemiBold'
          mr={8}
          color={theme.palette.black.A100}
        >
          <FormattedMessage id='referral.referFriendGetRewarded' />
        </Text>
        <StyledGiftImage src={Gift} />
      </Flex>
      <Text
        variant='h5'
        fontWeight='fontWeightMedium'
        color={theme.palette.black.A100}
      >
        <FormattedMessage id='referral.howItWorks' />
      </Text>
      <ReferralContainer>
        <StyledReferralInfoContainer>
          {referralData.map((x) => (
            <ReferralInfo key={x.title} {...x} />
          ))}
        </StyledReferralInfoContainer>
        <StyledCopyLinkContainer>
          <Text
            variant='h5'
            fontWeight='fontWeightMedium'
            color={theme.palette.black.A100}
            data-testid='referral-link-text'
          >
            {/* //TODO: remove this static link when we have acutual referral code */}
            {referralLink}
          </Text>
          <StyledCopyButton
            data-testid='referral-link-copy-button'
            onClick={onCopyButtonClick}
          >
            {isCopied ? (
              <FormattedMessage id='misc.copied' />
            ) : (
              <FormattedMessage id='misc.copy' />
            )}
          </StyledCopyButton>
        </StyledCopyLinkContainer>
      </ReferralContainer>
    </StyledContainer>
  );
};

export default Referral;
